import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import SydInput from '../../../../../../components/commonDesign/SydInput'

const StringEditor = forwardRef(({ value, onChange, onBlur, disabled }, ref) => {
  return (
    <SydInput
      ref={ref}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      disabled={disabled}
    />
  )
})

StringEditor.displayName = 'StringEditor'

StringEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
}

export default StringEditor
